import React, { useState, useEffect, Suspense } from "react";

const Lottie = React.lazy(() => import("lottie-react"));

export default function LazyLottieAnimation(props) {
  const { animationPath, className, fallback } = props;
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    let isMounted = true;
    fetch(animationPath, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load animation: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((jsonData) => {
        if (isMounted) {
          setAnimationData(jsonData);
        }
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return;
        }
        console.error("Error loading animation:", err);
      });
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [animationPath]);

  if (!animationData) return fallback;

  const lottieProps = {
    animationData,
    loop: true,
  };

  if (className) {
    lottieProps.className = className;
  }

  return (
    <Suspense fallback={fallback}>
      <Lottie {...lottieProps} />
    </Suspense>
  );
}
